import { computed, reactive } from 'vue';
import type { RouteLocationRaw } from 'vue-router';

interface Breadcrumb {
    parts: BreadcrumbPart[];
}

interface BreadcrumbPart {
    title: string;
    route?: RouteLocationRaw;
    href?: string;
}

const state = reactive<Breadcrumb>({
    parts: [],
});

export default function useBreadcrumb() {
    const setBreadcrumb = (parts: BreadcrumbPart[]): void => {
        state.parts = parts;
    };

    const breadcrumb = computed(() => state.parts);

    return { breadcrumb, setBreadcrumb };
}
